import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #ccc;
  cursor: pointer;
`;

const DropdownBody = styled(motion.div)`
  position: absolute;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  z-index: 10;
  overflow: hidden;
  ${({ position }) => (position === "top" ? "bottom: 100%;" : "top: 100%;")}
`;

const SpSelector = ({
  label,
  selectedOption,
  onOptionSelect,
  children,
  className,
  position = "bottom", // 'top' or 'bottom'
  showArrow = true,
  renderHeader,
  closeOnSelect = true,
  onClose,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const dropdownVariants = {
    hidden: {
      opacity: 0,
      y: position === "bottom" ? -10 : 10,
      transition: { duration: 0.2 },
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.2 },
    },
  };

  return (
    <DropdownContainer
      ref={dropdownRef}
      className={`${className} _newDropDown`}
      {...props}
    >
      <DropdownHeader
        onClick={toggleDropdown}
        className={`${className}-header _newDropDown--header`}
      >
        {renderHeader ? renderHeader() : selectedOption || label}

        {showArrow &&
          (isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />)}
      </DropdownHeader>
      <AnimatePresence>
        {isOpen && (
          <DropdownBody
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={dropdownVariants}
            // style={{ [position]: "100%" }}
            position={position}
            className={`${className}-body _newDropDown--body`}
          >
            {React.Children.map(children, (child) =>
              React.cloneElement(child, {
                onClick: (e) => {
                  e.stopPropagation();

                  if (child.props.onClick) {
                    child.props.onClick(e);
                  }
                  onOptionSelect && onOptionSelect(child.props.value);
                  closeOnSelect && setIsOpen(false);
                },
              })
            )}
          </DropdownBody>
        )}
      </AnimatePresence>
    </DropdownContainer>
  );
};

export default SpSelector;
